import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=c3d74d9a&scoped=true&"
import script from "./lock.vue?vue&type=script&lang=ts&"
export * from "./lock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d74d9a",
  null
  
)

export default component.exports